import React from "react";
const FontsInitializerContext = React.createContext();
const FontsInitializerContextProvider = FontsInitializerContext.Provider;
export { FontsInitializerContext, FontsInitializerContextProvider };
